module.exports = __webpack_public_path__ + "static/media/myProfile.cdd3683d.svg";